export default __webpack_public_path__ + "static/media/gallery-img01.da378d3f.jpg";